import { useEffect } from "react";
import { BrowserRouter as Router, useRoutes } from "react-router";

import { AppError } from "./api/client";
import Alerts from "./containers/Alerts";
import MagicLink from "./containers/MagicLink";
import NotFound from "./containers/NotFound";
import Success from "./containers/Success";
import { setQueryErrorHandler } from "./providers/QueryProvider";
import { useToast } from "./providers/ToastProvider";

const App = () =>
  useRoutes([
    {
      path: "/orgs/:orgID/links/:linkID/success",
      element: <Success />,
    },
    {
      path: "/staging/orgs/:orgID/links/:linkID/success",
      element: <Success />,
    },
    {
      path: "/orgs/:orgID/links/:linkID",
      element: <MagicLink prodEnv={true} />,
    },
    {
      path: "/staging/orgs/:orgID/links/:linkID",
      element: <MagicLink prodEnv={false} />,
    },
    {
      path: "*",
      element: <NotFound />,
    },
  ]);

const AppWrapper = () => {
  const { addToast } = useToast();

  useEffect(() => {
    setQueryErrorHandler((error: AppError) => {
      addToast({
        kind: "ERROR",
        message: error.error.message ?? "Unknown error",
      });
    });
  }, [addToast]);

  return (
    <>
      <Alerts />
      <Router>
        <App />
      </Router>
    </>
  );
};

export default AppWrapper;
